import { h, Component } from "preact";
import Api from "../api";
import Navigation, { Pages } from "../navigation";
import "./header.scss";
import { MoreVertical } from "preact-feather";
import { Observable } from "@hibas123/utils";
import theme from "../theme";

async function clearCache(evt) {
   evt.preventDefault();
   if ("serviceWorker" in navigator) {
      let reg = await navigator.serviceWorker.getRegistration();
      if (reg) reg.active.postMessage("clear_cache");
   }
}

export default function () {
   return (
      <div class="header">
         <header style="border-bottom: unset;">
            <span
               class="logo"
               onClick={(evt) =>
                  (evt.preventDefault() as any) ||
                  Navigation.setPage(Pages.Library, undefined)
               }
            >
               EBook Store
            </span>
            <span style="position:absolute; right: 0;">
               <div class="dd">
                  <button class="db" aria-label="more">
                     <MoreVertical />
                  </button>
                  <div class="dc">
                     <a
                        href="#"
                        onClick={(evt) =>
                           (evt.preventDefault() as any) || Api.logout()
                        }
                     >
                        logout
                     </a>
                     <a
                        href="#"
                        onClick={(evt) =>
                           (evt.preventDefault() as any) ||
                           Navigation.setPage(Pages.Stats, undefined)
                        }
                     >
                        show stats
                     </a>
                     <a href="#" onClick={clearCache}>
                        clear site cache
                     </a>
                     <div style="display: flex;">
                        <a
                           href="#"
                           onClick={(e) => {
                              e.preventDefault();
                              theme.change(0);
                           }}
                        >
                           auto
                        </a>
                        <a
                           href="#"
                           onClick={(e) => {
                              e.preventDefault();
                              theme.change(1);
                           }}
                        >
                           light
                        </a>
                        <a
                           href="#"
                           onClick={(e) => {
                              e.preventDefault();
                              theme.change(2);
                           }}
                        >
                           dark
                        </a>
                     </div>
                     <p style="padding: 1em">Version: 2.2</p>
                  </div>
               </div>
            </span>
         </header>
      </div>
   );
}
